// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"ReferralCodeBanner_tooltip__3ZQUA"};